import StartLayout from './StartLayout';

export default StartLayout;
